var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{staticClass:"w-full",attrs:{"color":"danger","type":"filled"},domProps:{"textContent":_vm._s('Reset')},on:{"click":function($event){$event.preventDefault();return _vm.restart.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }